module.exports = __webpack_public_path__ + "bin/920401e8d1ff2312b16401598f965369.svg";